
const SET_INVOICES= (state, fetchedInvoices) => {
  state.invoices = fetchedInvoices;
  state.outDated=false;
};

const SET_SEARCH_TERMS = (state, searchTerms) =>{
  state.searchTerms = searchTerms;
}

const SET_LOADING = (state, loadingState)=>{
  state.loading = loadingState;
}

const SET_LOADING_INVOICE = (state, loadingInvoice)=>{
  state.loadingInvoice=loadingInvoice;
}

const SET_SELECTED_INVOICE = (state, invoice)=>{
  state.selectedInvoice = invoice;
  // if(state.selectedIndex!=null){
  //   state.invoices[state.selectedIndex] = invoice;
  // }
}

const SET_SELECTED_INDEX = (state, index) =>{
  state.selectedIndex = index;
}
const SET_STATUS_FILTER = (state, statusFitler)=>{
  state.filters.status = statusFitler;
}

const SET_INVOICE_DOWNLOADING= (state, invoiceDownloading) =>{
  state.invoiceDownloading=invoiceDownloading;
}

const UPDATE_SELECTED_INVOICE = (state, invoice)=>{
  if (_.get(invoice, 'customer.usualName') != null) {
    invoice.customer.usual_name = _.get(invoice, 'customer.usualName');
  }
  Object.assign(state.selectedInvoice, invoice);
 
  if(state.selectedIndex!=null){
    Object.assign(state.invoices[state.selectedIndex], invoice);
  }
}

const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
}

const SET_ORDERNAME_AND_DIRECTION = (state, {orderName, direction})=>{
  state.orderBy.orderName = orderName;
  state.orderBy.direction = direction;
}

const SET_SORT_ICON = (state, icon)=>{
  state.sort_icon =icon;
}

const SET_COUNT = (state, count)=>{
  state.count = count;
}

const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}

const SET_PAGE = (state, page)=>{
  state.page = page;
}

const RESET_FILTERS = (state)=>{
  state.filters.status = [];
  state.filters.date = null;
  state.filters.paidAt = null;
  state.filters.checkedCustomerClasses= [];
  state.filters.checkedInvoiced = [];
  state.filters.checkedReps = [];
  state.filters.withoutReps=false;
  state.filters.customerId = null;
  state.filters.productId = null;
  state.searchTerms = '';
}

const SET_DATE_FILTER = (state, dateFilter)=>{
  state.filters.date = dateFilter;
}

const SET_PAID_AT_FILTER = (state, paidAtFilter) => {
  state.filters.paidAt = paidAtFilter;
}

const SET_SELECTED_INVOICE_STATUS = (state, status)=>{
  Object.assign(state.selectedInvoice.status, status);
  state.selectedInvoice.status.update_at = new Date();
  if(state.selectedIndex!=null){
    Object.assign(state.invoices[state.selectedIndex].status, status);
    state.invoices[state.selectedIndex].updated_at = new Date();
  }
}

const DELETE_SELECTED_INVOICE_FILE = (state, id) =>{
  let index = _.findIndex(state.selectedInvoice.files, file=>{
    return file.id==id;
  })
  state.selectedInvoice.files.slice(index,1);
}

const UPDATE_OUTSTANDING_AMOUNT = (state, {paid, invoiceId})=>{
  if(state.selectedInvoice!=null && state.selectedInvoice.id==invoiceId){
    state.selectedInvoice.balance.outstanding -= paid;
    state.selectedInvoice.balance.paid += paid;

    if(state.selectedIndex!=null && state.invoices[state.selectedIndex]!=null && state.invoices[state.selectedIndex].id==invoiceId){
      state.invoices[state.selectedIndex].balance.outstanding -= paid;
      state.invoices[state.selectedIndex].balance.paid += paid;
    }
  }
}

const UPDATE_SELECTED_INVOICE_STATUS = (state, status)=>{
  state.selectedInvoice.status = status;
  if(state.selectedIndex!=null){
    state.invoices[state.selectedIndex].status = status;
  }
}

const ADD_PAYMENT_TO_SELECTED_INVOICE = (state, payment)=>{
  state.selectedInvoice.payments.push(payment);
}
const DELETE_SELECTED_INVOICE_PAYMENT = (state, {index, payment})=>{
  state.selectedInvoice.payments.splice(index,1);
}

const CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER = (state, checkedCustomerClasses)=>{
  state.filters.checkedCustomerClasses = checkedCustomerClasses;
}

const CHANGE_INVOICED_FILTER = (state, checkedInvoiced)=>{
  state.filters.checkedInvoiced = checkedInvoiced;
}


const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const SET_CREDIT_NOTE = (state, creditNote)=>{
  if(state.selectedInvoice.credit_notes!=null){
    state.selectedInvoice.credit_notes = [];
  }
  state.selectedInvoice.credit_notes.push(creditNote);
}

const UPDATE_INVOCIES = (state, invoices)=>{
  state.invoices.push(...invoices);
}

const SET_CHECKED_REPS = (state, checkedReps) => {
  state.filters.checkedReps = checkedReps;
}

const SET_WITHOUT_REPS_FILTER = (state, withoutReps) =>{
  state.filters.withoutReps = withoutReps;
}

const SET_FILTER_CUSTOMER_ID = (state, customerId) => {
  state.filters.customerId = customerId;
}
const SET_FILTER_PRODUCT_ID = (state, productId) => {
  state.filters.productId = productId;
}


export default {
  SET_MODE,
  SET_INVOICES,
  UPDATE_INVOCIES,
  SET_SEARCH_TERMS,
  SET_LOADING,
  SET_LOADING_INVOICE,
  SET_SELECTED_INVOICE,
  SET_SELECTED_INDEX,
  INVALIDATE_LIST,
  SET_ORDERNAME_AND_DIRECTION,
  SET_SORT_ICON,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_STATUS_FILTER,
  RESET_FILTERS,
  SET_DATE_FILTER,
  SET_INVOICE_DOWNLOADING,
  SET_SELECTED_INVOICE_STATUS,
  UPDATE_SELECTED_INVOICE,
  DELETE_SELECTED_INVOICE_FILE,
  UPDATE_OUTSTANDING_AMOUNT,
  UPDATE_SELECTED_INVOICE_STATUS,
  ADD_PAYMENT_TO_SELECTED_INVOICE,
  DELETE_SELECTED_INVOICE_PAYMENT,
  CHANGE_CHECKED_CUSTOMER_CLASSES_FILTER,
  SET_CREDIT_NOTE,
  CHANGE_INVOICED_FILTER,
  SET_CHECKED_REPS,
  SET_WITHOUT_REPS_FILTER,
  SET_FILTER_CUSTOMER_ID,
  SET_FILTER_PRODUCT_ID,
  SET_PAID_AT_FILTER
};
